import { api } from '@/api/http';
import { money } from '@/lib/format';
import LoadingWrapper from '@/components/loading-wrapper';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { InputGroup, InputGroupAddon, InputGroupInput, InputGroupText } from '@/components/ui/input-group';
import { Label } from '@/components/ui/label';
import { DollarSignIcon, PercentIcon } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

const WORKER_SHARE = 60;

export default function ProfitWidget() {
	const [workerNickname, setWorkerNickname] = useState('');
	const [amount, setAmount] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const parsedAmount = Number(amount);
	const isValidAmount = amount && !isNaN(parsedAmount) && parsedAmount > 0;
	const workerShare = isValidAmount ? parsedAmount * (WORKER_SHARE / 100) : 0;

	async function handleSubmit() {
		setIsLoading(true);
		api
			.post('/create-profit', {
				workerName: workerNickname,
				amount: parsedAmount,
			})
			.then(() => {
				setAmount('');
				toast.success('Профит успешно поставлен');
			})
			.finally(() => {
				setIsLoading(false);
			});
	}

	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-4 flex'>
				<div className='flex items-center gap-3'>
					<div className='rounded-lg bg-chart-5/15 p-2'>
						<DollarSignIcon className='text-chart-5' size={20} />
					</div>
					<div>
						<CardTitle className='text-chart-5'>Поставить профит</CardTitle>
						<CardDescription>Назначение доли воркеру</CardDescription>
					</div>
				</div>
			</CardHeader>

			<LoadingWrapper show={isLoading}>
				<CardContent className='px-4 py-4 flex flex-col gap-4'>
					<div className='flex flex-col gap-1.5'>
						<Label className='text-sm'>Никнейм воркера</Label>
						<InputGroup>
							<InputGroupAddon>
								<InputGroupText>#</InputGroupText>
							</InputGroupAddon>
							<InputGroupInput onChange={e => setWorkerNickname(e.target.value)} value={workerNickname} />
						</InputGroup>
					</div>
					<div className='flex flex-col gap-1.5'>
						<Label className='text-sm'>Сумма профита</Label>
						<InputGroup>
							<InputGroupAddon>
								<InputGroupText>$</InputGroupText>
							</InputGroupAddon>
							<InputGroupInput
								className='appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none'
								type='number'
								placeholder='0.00'
								onChange={e => setAmount(e.target.value)}
								value={amount}
							/>
							<InputGroupAddon align='inline-end'>
								<InputGroupText>USD</InputGroupText>
							</InputGroupAddon>
						</InputGroup>
					</div>

					{isValidAmount && (
						<div className='rounded-lg bg-muted/50 border border-border p-3'>
							<div className='flex items-center gap-2 text-sm text-muted-foreground mb-1'>
								<PercentIcon size={14} />
								<span>Доля воркера: {WORKER_SHARE}%</span>
							</div>
							<p className='text-lg font-semibold tabular-nums text-chart-5'>{money.format(workerShare)} $</p>
						</div>
					)}
				</CardContent>

				<CardFooter className='border-t px-4 py-4'>
					<Button
						className='w-full'
						variant='default'
						disabled={!workerNickname.trim() || !isValidAmount}
						onClick={handleSubmit}
					>
						Поставить
					</Button>
				</CardFooter>
			</LoadingWrapper>
		</Card>
	);
}
